<template>
  <div class="continuous">
    <div class="continuous-box"></div>
    <div class="tip">
      <div class="add" v-if="continuousData.coin > 0">
        <div class="icon"></div>
        <div class="addcoin">+{{continuousData.coin}}</div>
      </div>
      <div class="add" v-if="continuousData.teamScore > 0">
        <div class="dian"></div>
        <div class="addcoin adddian">+{{continuousData.teamScore}}</div>
      </div>
    </div>
    <audio :src="audio_url" ref="audio"></audio>
  </div>
</template>
<script>
import lottie from "lottie-web-limi";
import utils from "utils";
export default {
  name: "continuous",
  data() {
    return {
      anim: null,
      interval:null,
      audio_url:''
    };
  },
  props: {
    continuousData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    //防止动画未加载成功不能消失
    this.interval = setTimeout(this.animEnd,4000);
    this.$nextTick(this.animInit);
  },
  methods: {
    animInit() {
      const baseUrl = this.continuousData.baseUrl;
      const directory = this.continuousData.directory;
      const level = this.continuousData.level;
      const jsonPath =`${baseUrl}${directory}${level}/${level}.json?t=${this.continuousData.updateTime}`;
      this.audio_url = `${baseUrl}${directory}${level}/${level}.mp3`
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".continuous-box"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: false,
        path: jsonPath
        // path:"http://127.0.0.1:65005/a/a.json"
      });
      //json文件准备就绪
      this.anim.addEventListener("config_ready", this.configReady);
      //当所有图像加载成功或错误时
      this.anim.addEventListener("loaded_images",this.loadedImages);
      //将元素添加到DOM时
      this.anim.addEventListener("DOMLoaded", this.domLoaded);
      //动画执行完成
      this.anim.addEventListener("complete",this.complete);
      //当无法加载动画的一部分时
      this.anim.addEventListener("data_failed",this.dataFailed);
      
      // this.anim.addEventListener("enterFrame", ()=>{
      //   console.log(this.anim.getDuration(true),this.anim.currentFrame);//播放总帧和当前帧
      // });
    },
    configReady() {
      this.rpTitleByJson(this.continuousData.name);
    },
    domLoaded() {
      this.rpSuccessNum(this.continuousData.num);
      if(utils.issafariBrowser()){
        this.playAnim();
        this.$refs.audio.play();
      }
    },
    loadedImages(){
      this.playAnim();
      this.$refs.audio.play();
    },
    complete(){
      this.animEnd();
    },
    dataFailed(){
      this.animEnd();
    },
    getTitleId(title){
      const pattern = /^[A-Za-z][A-Za-z\s]*[A-Za-z]$/;
      if (pattern.test(title)) {
        if (title.length <= 12) {
          return "enTitleBig";
        } else {
          return "enTitleSmall";
        }
      } else {
        if (title.length <= 5) {
          return "zhTitleBig";
        } else {
          return "zhTitleSmall";
        }
      }
    },
    rpTitleByJson(title) {
      // zh:  1-5、6-8;  en:  1-12、13-17
      const titles = ['zhTitleBig', 'zhTitleSmall', 'enTitleBig', 'enTitleSmall'];
      let titleId = this.getTitleId(title);
      // console.log(titleId)
      let layers = this.anim.animationData.layers;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].ln === titleId) {
          layers[i].t.d.k[0].s.t = title ? title.trim() : "";
        } else if (titles.indexOf(layers[i].ln) !== -1) {
          layers[i].t.d.k[0].s.t = "";
        }
      }
    },
    rpSuccessNum(num) {
      const element = document.getElementById("successNum");
      element.querySelector("tspan").innerHTML = num;
    },
    playAnim() {
      this.anim.play();
      // this.anim.goToAndStop(200)
    },
    animEnd() {
      if(this.anim){
        this.anim.removeEventListener("loaded_images", this.loadedImages);
        this.anim.removeEventListener("complete", this.complete);
        this.anim.removeEventListener("data_failed", this.dataFailed);
        this.anim.removeEventListener("DOMLoaded", this.domLoaded);
        this.anim.removeEventListener("config_ready", this.configReady);
        this.anim.destroy();
      }
      clearTimeout(this.interval)
      this.anim = null;
      this.$refs.audio.pause();
      this.$emit("animEnd");
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less" scoped>
.continuous {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 80;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  .continuous-box {
    margin-top: -120px;
    height: 670px;
    width: 670px;
  }
  .tip{
    display: flex;
    margin: -80px 0px 0 0;
    .add{
      background: rgba(0,0,0,.3);
      width: 100px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color:#EC8C05;
      font-size: 20px;
      border-radius: 23px;
      display: flex;
      margin-right: 25px;
      &:last-child{
        margin:0;
      }
      .icon{
        width: 35px;
        height: 35px;
        background: url(../../../assets/img/common/coin.png) no-repeat;
        background-size: cover;
      }
      .dian{
        width: 35px;
        height: 35px;
        background: url(../../../assets/img/common/energy.png) no-repeat;
        background-size: cover;
      }
      .addcoin{
        margin-left: 15px;
      }
      .adddian{
        color: #00A074;
      }
    }
  }
  @media screen and (max-height: 800px) {
     .continuous-box {
      margin-top: -100px;
      width: 450px;
      height:450px;
    }
    .tip{
      .add{
        width: 80px;
        height: 28px;
        font-size: 18px;
        line-height: 28px;
        .icon{
          width: 28px;
          height: 28px;
        }
        .dian{
          width: 28px;
          height: 28px;
        }
      }
    }
  }
  audio{
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/video/continuous.vue